"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var _connectUpgradeData = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData"));

var _ProductActivationButton = _interopRequireDefault(require("ui-addon-upgrades/_core/productActivation/ProductActivationButton"));

var PRODUCT_ACTIVATION = _sources.sourceKeys.PRODUCT_ACTIVATION;

var _default = (0, _connectUpgradeData.default)(_ProductActivationButton.default, PRODUCT_ACTIVATION);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/button/UIProductActivationButton.js
// module id = 767
// module chunks = 5 6